export const userFromDto = (dto) => ({
  id: dto.id,
  username: dto.username,
  fullName: dto.full_name,
  softsegurosAdvisorId: dto.softseguros_vendedor_id,
  softsegurosAdvisorName: dto.softseguros_vendedor_nombre,
  softsegurosProfileId: dto.softseguros_perfil_id,
  branches: dto.sedes,
});